import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react"; // Correct import for QRCodeSVG

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://pelaj-forever2025-production.up.railway.app/weddingAccess";

function InvitationPage() {
  const { qrCode } = useParams();
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [guestName, setGuestName] = useState("Guest Name");
  const [eventName, setEventName] = useState("PELAJ-Forever");
  const [eventDate, setEventDate] = useState("27th December, 2025");
  const [eventTime, setEventTime] = useState("8:00 AM prompt");
  const [eventVenue, setEventVenue] = useState("The Wedding Venue");
  const [qrCodeData, setQrCodeData] = useState("");
  const [hasCheckedIn, setHasCheckedIn] = useState(false);
  const [partyBandCode, setPartyBandCode] = useState("");

  const HEART_SRC = process.env.PUBLIC_URL + "/heart.png";

  const invitationLink = `${window.location.origin}${location.pathname}`;

  useEffect(() => {
    if (!qrCode) {
      setQrCodeData(`${API_BASE_URL}/qr/sample-code`);  
      setLoading(false);
      return;
    }

    const fetchInvitation = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/invitations/${qrCode}`);
        if (!res.ok) {
          throw new Error("Failed to load invitation");
        }

        const data = await res.json();

        if (data.guestName) setGuestName(data.guestName);
        if (data.eventName) setEventName(data.eventName);
        if (data.eventDateFormatted) setEventDate(data.eventDateFormatted);
        if (data.eventTimeFormatted) setEventTime(data.eventTimeFormatted);
        if (data.eventVenue) setEventVenue(data.eventVenue);
        if (typeof data.hasCheckedIn === "boolean") setHasCheckedIn(data.hasCheckedIn);
        if (data.partyBandCode) setPartyBandCode(data.partyBandCode);


        setQrCodeData(`${API_BASE_URL}/qr/${qrCode}`);  // Update qrCodeData with the generated QR code link

        setLoading(false);
      } catch (err) {
        console.error(err);
        setError("Unable to load your invitation. Please try again later.");
        setLoading(false);
      }
    };

    fetchInvitation();
  }, [qrCode]);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(invitationLink);
      alert("Invitation link copied to clipboard!");
    } catch (err) {
      console.error(err);
      alert("Unable to copy link. Please copy it manually.");
    }
  };

  return (
    <div className="invitation-page">
      {/* Top navbar */}
      <header className="nav-bar">
        <div className="nav-left">
          <div className="nav-logo-circle">PAJ</div>
          <span className="nav-title">{eventName}</span>
        </div>
        <nav className="nav-links">
          <a href="#home">Home</a>
          <a href="#save-the-date">Save The Date</a>
          <a href="#event-venue">Event Venue</a>
          <a href="#hire-developer" className="nav-highlight">
            Hire Developer
          </a>
        </nav>
      </header>

      {/* Main content */}
      <main className="invitation-container">
        <section className="invitation-card">
          <div className="invitation-card-header" style={{ backgroundColor: "#000080", color: "#fff" }}>
            <div className="invitation-logo-circle">PELAJ</div>
            <h2 className="invitation-title">Your Personal Invitation Access</h2>
            <p className="invitation-subtitle">
            The QR code be scanned to gain entrance
            </p>
          </div>

          <div className="qr-section">
            {loading ? (
                <p className="loading-text">Loading your invitation...</p>
            ) : error ? (
                <p className="error-text">{error}</p>
            ) : hasCheckedIn ? (
                <div className="band-wrapper">
                <div className="band-title">Party Band Code</div>
                <div className="band-code">{partyBandCode || "—"}</div>
                <p className="band-note">
                    You have already checked in successfully. Please show this code at the gate.
                </p>
                </div>
            ) : (
                <div className="qr-wrapper">
                <QRCodeSVG
                    value={qrCodeData}
                    size={260}
                    level="H"
                    includeMargin={false}
                    fgColor="#0A1B3D"
                    bgColor="#F7FBFF"
                    imageSettings={{
                    src: HEART_SRC,
                    height: 56,
                    width: 56,
                    excavate: true,
                    }}
                />
                </div>
            )}
          </div>

          <div className="guest-details-card">
            <h3 className="guest-details-title">Guest Details</h3>
            <p className="guest-details-text">
              <span className="guest-label">Name:</span> {guestName}
            </p>
            <p className="guest-details-text">
              <span className="guest-label">Date &amp; Time:</span>{" "}
              {eventDate}, {eventTime}
            </p>
            <p className="guest-details-text">
              <span className="guest-label">Venue:</span> {eventVenue}
            </p>
          </div>

          {!hasCheckedIn && (
            <>
                <div className="button-group">
                <a href={qrCodeData} download="wedding-qr-code.png" className="btn btn-primary">
                    <span className="btn-icon">⬇</span>
                    Download QR Code
                </a>

                <button type="button" className="btn btn-outline" onClick={handleCopyLink}>
                    <span className="btn-icon">📋</span>
                    Copy Link
                </button>
                </div>

                <p className="info-text">
                This QR code contains your personal wedding access to the event. Save it to your phone for easy access.
                </p>
            </>
          )}
        </section>

        <button className="floating-button" aria-label="Celebrate">
          🎉
        </button>
      </main>

      {/* ✅ Footer */}
      <footer className="invite-footer">
        <div className="invite-footer-inner">
          <div className="invite-footer-brand">
            <span className="invite-footer-badge">PAJ</span>
            <span className="invite-footer-names">Ajoke-Ade &amp; Oluwapelumi</span>
          </div>

          <div className="invite-footer-divider" />

          <div className="invite-footer-meta">
            <div>
              Made with <span className="invite-footer-heart">❤️</span> By Oluwapelumi
              Taiwo (Perry)
            </div>
            <div>© 2025 PELAJ-Forever. All rights reserved.</div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default InvitationPage;





// import React, { useEffect, useState } from "react";
// import React, { useEffect, useState, useRef } from "react";
// import { useParams, useLocation } from "react-router-dom";
// // import { QRCodeSVG } from "qrcode.react"; 
// import { QRCodeCanvas } from "qrcode.react";

// const API_BASE_URL =
//   process.env.REACT_APP_API_BASE_URL || "https://pelaj-forever2025-production.up.railway.app/weddingAccess";

// function InvitationPage() {
//   const { qrCode } = useParams();
//   const location = useLocation();

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [guestName, setGuestName] = useState("Guest Name");
//   const [eventName, setEventName] = useState("PELAJ-Forever");
//   const [eventDate, setEventDate] = useState("27th December, 2025");
//   const [eventTime, setEventTime] = useState("8:00 AM prompt");
//   const [eventVenue, setEventVenue] = useState("The Wedding Venue");
//   const [qrCodeData, setQrCodeData] = useState("");
//   const [hasCheckedIn, setHasCheckedIn] = useState(false);
//   const [partyBandCode, setPartyBandCode] = useState("");

//   const HEART_SRC = process.env.PUBLIC_URL + "/heart.png";

//   const invitationLink = `${window.location.origin}${location.pathname}`;

//   useEffect(() => {
//     if (!qrCode) {
//       setQrCodeData(`${API_BASE_URL}/qr/sample-code`);  
//       setLoading(false);
//       return;
//     }

//     const fetchInvitation = async () => {
//       try {
//         const res = await fetch(`${API_BASE_URL}/invitations/${qrCode}`);
//         if (!res.ok) {
//           throw new Error("Failed to load invitation");
//         }

//         const data = await res.json();

//         if (data.guestName) setGuestName(data.guestName);
//         if (data.eventName) setEventName(data.eventName);
//         if (data.eventDateFormatted) setEventDate(data.eventDateFormatted);
//         if (data.eventTimeFormatted) setEventTime(data.eventTimeFormatted);
//         if (data.eventVenue) setEventVenue(data.eventVenue);
//         if (typeof data.hasCheckedIn === "boolean") setHasCheckedIn(data.hasCheckedIn);
//         if (data.partyBandCode) setPartyBandCode(data.partyBandCode);


//         setQrCodeData(`${API_BASE_URL}/qr/${qrCode}`);  // Update qrCodeData with the generated QR code link

//         setLoading(false);
//       } catch (err) {
//         console.error(err);
//         setError("Unable to load your invitation. Please try again later.");
//         setLoading(false);
//       }
//     };

//     fetchInvitation();
//   }, [qrCode]);

//   const handleCopyLink = async () => {
//     try {
//       await navigator.clipboard.writeText(invitationLink);
//       alert("Invitation link copied to clipboard!");
//     } catch (err) {
//       console.error(err);
//       alert("Unable to copy link. Please copy it manually.");
//     }
//   };

//   const qrWrapRef = useRef(null);

//   const handleDownloadQr = () => {
//     try {
//         const canvas = qrWrapRef.current?.querySelector("canvas");
//         if (!canvas) {
//         alert("QR code not ready yet. Please wait a second and try again.");
//         return;
//         }

//         const pngUrl = canvas.toDataURL("image/png");

//         const a = document.createElement("a");
//         a.href = pngUrl;
//         a.download = `pelaj-invitation-${qrCode || "qr"}.png`;
//         document.body.appendChild(a);
//         a.click();
//         a.remove();
//     } catch (e) {
//         console.error(e);
//         alert("Unable to download on this device. Try a different browser (Chrome) or take a screenshot.");
//     }
//   };


//   return (
//     <div className="invitation-page">
//       {/* Top navbar */}
//       <header className="nav-bar">
//         <div className="nav-left">
//           <div className="nav-logo-circle">PAJ</div>
//           <span className="nav-title">{eventName}</span>
//         </div>
//         <nav className="nav-links">
//           <a href="#home">Home</a>
//           <a href="#save-the-date">Save The Date</a>
//           <a href="#event-venue">Event Venue</a>
//           <a href="#hire-developer" className="nav-highlight">
//             Hire Developer
//           </a>
//         </nav>
//       </header>

//       {/* Main content */}
//       <main className="invitation-container">
//         <section className="invitation-card">
//           <div className="invitation-card-header" style={{ backgroundColor: "#000080", color: "#fff" }}>
//             <div className="invitation-logo-circle">PELAJ</div>
//             <h2 className="invitation-title">Your Personal Invitation Access</h2>
//             <p className="invitation-subtitle">
//             The QR code be scanned to gain entrance
//             </p>
//           </div>

//           <div className="qr-section">
//             {loading ? (
//                 <p className="loading-text">Loading your invitation...</p>
//             ) : error ? (
//                 <p className="error-text">{error}</p>
//             ) : hasCheckedIn ? (
//                 <div className="band-wrapper">
//                 <div className="band-title">Party Band Code</div>
//                 <div className="band-code">{partyBandCode || "—"}</div>
//                 <p className="band-note">
//                     You have already checked in successfully. Please show this code at the gate.
//                 </p>
//                 </div>
//             ) : (
//                 <div className="qr-wrapper" ref={qrWrapRef}>
//                 <QRCodeCanvas
//                     value={qrCodeData}
//                     size={260}
//                     level="H"
//                     includeMargin={false}
//                     fgColor="#0A1B3D"
//                     bgColor="#F7FBFF"
//                     imageSettings={{
//                     src: HEART_SRC,
//                     height: 56,
//                     width: 56,
//                     excavate: true,
//                     }}
//                     className="qr-svg"
//                 />
//                 </div>
//                 // <div className="qr-wrapper">
//                 // <QRCodeSVG
//                 //     value={qrCodeData}
//                 //     size={260}
//                 //     level="H"
//                 //     includeMargin={false}
//                 //     fgColor="#0A1B3D"
//                 //     bgColor="#F7FBFF"
//                 //     imageSettings={{
//                 //     src: HEART_SRC,
//                 //     height: 56,
//                 //     width: 56,
//                 //     excavate: true,
//                 //     }}
//                 //     className="qr-svg"
//                 // />
//                 // </div>
//             )}
//           </div>

//           <div className="guest-details-card">
//             <h3 className="guest-details-title">Guest Details</h3>
//             <p className="guest-details-text">
//               <span className="guest-label">Name:</span> {guestName}
//             </p>
//             <p className="guest-details-text">
//               <span className="guest-label">Date &amp; Time:</span>{" "}
//               {eventDate}, {eventTime}
//             </p>
//             <p className="guest-details-text">
//               <span className="guest-label">Venue:</span> {eventVenue}
//             </p>
//           </div>

//           {!hasCheckedIn && (
//             <>
//                 <div className="button-group">
//                 <button type="button" className="btn btn-primary" onClick={handleDownloadQr}>
//                     <span className="btn-icon">⬇</span>
//                     Download QR Code
//                 </button>    
//                 {/* <a href={qrCodeData} download="wedding-qr-code.png" className="btn btn-primary">
//                     <span className="btn-icon">⬇</span>
//                     Download QR Code
//                 </a> */}

//                 <button type="button" className="btn btn-outline" onClick={handleCopyLink}>
//                     <span className="btn-icon">📋</span>
//                     Copy Link
//                 </button>
//                 </div>

//                 <p className="info-text">
//                 This QR code contains your personal wedding access to the event. Save it to your phone for easy access.
//                 </p>
//             </>
//           )}
//         </section>

//         <button className="floating-button" aria-label="Celebrate">
//           🎉
//         </button>
//       </main>

//       {/* ✅ Footer */}
//       <footer className="invite-footer">
//         <div className="invite-footer-inner">
//           <div className="invite-footer-brand">
//             <span className="invite-footer-badge">PAJ</span>
//             <span className="invite-footer-names">Ajoke-Ade &amp; Oluwapelumi</span>
//           </div>

//           <div className="invite-footer-divider" />

//           <div className="invite-footer-meta">
//             <div>
//               Made with <span className="invite-footer-heart">❤️</span> By Oluwapelumi
//               Taiwo (Perry)
//             </div>
//             <div>© 2025 PELAJ-Forever. All rights reserved.</div>
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// }

// export default InvitationPage;
